export default {
  presetSelectPlaceholder: 'Select preset',
  modalTitle: 'Sample presets',
  currentSelection: 'Current selection',
};
